<template>
    <dx-row ref="head" v-bind="$attrs" v-on="$listeners" :row="row"  :style="{ color: '#41464b' }">
      <slot />
    </dx-row>
</template>

<script>
import { DxTable,  DxGrid, DxTableHeaderRow } from "@devexpress/dx-vue-grid-bootstrap4";

export default {
  inheritAttrs: false,
  props: ["row"],  
  components: {
    DxRow: DxTable.components.DxRow
  }
};
</script>

